<template>
	<div data-tour-scope="social">
		<v-main>
			<v-container fluid class="sp-page">
				<div class="sp-top">
					<div>
						<div class="sp-title">Piano social</div>
						<div class="sp-muted">Ogni mese i prodotti da far vedere sui social: scelti tra i più visti, i più venduti, i nuovi e quelli in offerta, con la grafica dei tuoi template.</div>
					</div>
					<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
					<v-spacer></v-spacer>
					<v-btn text color="primary" data-tour="new" @click="nuovo"><v-icon left>mdi-plus</v-icon>Nuovo post</v-btn>
					<v-btn depressed color="primary" data-tour="generate" :loading="generando" @click="dialogGenera = true"><v-icon left>mdi-calendar-star</v-icon>Genera piano del mese</v-btn>
				</div>

				<SocialSettings
					:setting="setting"
					:templates="templates"
					:options="options"
					:lingue="lingue"
					:aperto="impostazioniAperte"
					@apri="impostazioniAperte = !impostazioniAperte"
					@salva="salvaImpostazioni"
					@nuovo-template="$router.push('/social-posts/templates/new')"
					@modifica-template="t => $router.push(`/social-posts/templates/${t._id}`)"
					@predefinito="rendiPredefinito"
					@elimina-template="eliminaTemplate"
				/>

				<SectionCard title="Post" icon="mdi-image-multiple-outline" :subtitle="total === 1 ? '1 post' : total + ' post'" class="mt-4">
					<div class="sp-filters" data-tour="filters">
						<v-text-field
							v-model="searchfield"
							label="Cerca per prodotto o titolo"
							outlined
							dense
							hide-details
							prepend-inner-icon="mdi-magnify"
							clearable
							class="sp-search"
							@keyup.enter="getSearch()"
							@click:clear="pulisciRicerca"
						/>
						<div class="sp-states">
							<v-chip small :outlined="settings.filters.status !== ''" :color="settings.filters.status === '' ? 'primary' : undefined" @click="settings.filters.status = ''">Tutti</v-chip>
							<v-chip
								v-for="(s, codice) in STATI"
								:key="codice"
								small
								:outlined="settings.filters.status !== codice"
								:color="settings.filters.status === codice ? s.colore : undefined"
								:text-color="settings.filters.status === codice ? 'white' : undefined"
								@click="settings.filters.status = codice"
							>
								<v-icon x-small left>{{ s.icona }}</v-icon
								>{{ s.label }}
							</v-chip>
						</div>
					</div>

					<div v-if="!getItems.length" class="sp-empty">
						<v-icon large color="grey lighten-1">mdi-image-multiple-outline</v-icon>
						<div>Nessun post{{ settings.filters.status || settings.search ? ' con questi filtri' : '' }}.</div>
						<div class="sp-muted">«Genera piano del mese» sceglie i prodotti e prepara i post per i giorni che restano.</div>
					</div>

					<v-data-table
						v-else
						:headers="headers"
						:items="getItems"
						:options.sync="settings.options"
						:server-items-length="total"
						must-sort
						class="elevation-0"
						:footer-props="{ 'items-per-page-options': listSize }"
						item-key="_id"
						data-tour="table"
						:hide-default-header="mobileCards"
						:class="{ 'table-cards': mobileCards }"
					>
						<template v-slot:body="{ items }">
							<!-- telefono: ogni post diventa una card -->
							<tbody v-if="mobileCards" class="sp-cards">
								<tr v-for="item in items" :key="item._id">
									<td :colspan="headers.length" class="px-0 py-1">
										<key-value-card :title="item.item_name || 'Post'" :fields="campiCard(item)" :image="item.image || ''">
											<template #actions>
												<SocialRowMenu :item="item" @edit="editItem" @publish="chiediPubblica" @status="cambiaStato" @download="scarica" @delete="deleteItem" />
											</template>
										</key-value-card>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr v-for="item in items" :key="item._id">
									<td class="pl-1 pr-0" style="width: 44px">
										<SocialRowMenu :item="item" @edit="editItem" @publish="chiediPubblica" @status="cambiaStato" @download="scarica" @delete="deleteItem" />
									</td>
									<td style="width: 64px">
										<div class="sp-thumb">
											<img v-if="item.image" :src="item.image" alt="" loading="lazy" />
											<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
										</div>
									</td>
									<td class="text-left">
										<div class="font-weight-medium">{{ item.item_name || '—' }}</div>
										<div class="sp-muted sp-payoff">{{ item.payoff || 'senza titolo' }}</div>
									</td>
									<td>
										<span class="sp-source"
											><v-icon x-small class="mr-1">{{ fonte(item.source).icona }}</v-icon
											>{{ fonte(item.source).label }}</span
										>
									</td>
									<td class="text-no-wrap">
										<v-icon v-for="p in item.platforms" :key="p" small :color="esitoColore(item, p)" :title="esitoTitolo(item, p)" class="mr-1">{{ social[p].icona }}</v-icon>
									</td>
									<td>
										<v-chip x-small label outlined :color="stato(item.status).colore" :title="item.error || ''">
											<v-icon x-small left>{{ stato(item.status).icona }}</v-icon
											>{{ stato(item.status).label }}
										</v-chip>
									</td>
									<td class="text-no-wrap">
										<template v-if="item.publishedAt">
											<div>{{ item.publishedAt | moment('DD/MM/YYYY HH:mm') }}</div>
											<div class="sp-muted">{{ quando(item.publishedAt) }}</div>
										</template>
										<span v-else class="sp-muted">—</span>
									</td>
								</tr>
							</tbody>
						</template>
					</v-data-table>
				</SectionCard>

				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
					{{ snackbar.text }}
					<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
				</v-snackbar>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogGenera" max-width="380">
			<v-card>
				<v-card-title class="headline">Generare il piano del mese?</v-card-title>
				<v-card-text class="text-left">
					Si scelgono i prodotti per i giorni che restano del mese ({{ setting.times || 0 }} post al mese), escludendo quelli già pubblicati di recente, e l'IA scrive un payoff per ognuno. I post
					nascono <strong>programmati</strong>: escono da soli alla data, a meno che tu non li cambi o annulli.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogGenera = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="genera"> Genera </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogPubblica" max-width="340">
			<v-card>
				<v-card-title class="headline">Pubblicare adesso?</v-card-title>
				<v-card-text class="text-left">Il post esce subito sui social scelti, senza aspettare la data programmata.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogPubblica = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="pubblica"> Pubblica </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirm" max-width="320">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text class="text-left">{{ testoElimina }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>
					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import SectionCard from '@/components/core/SectionCard.vue';
import { listRouteState } from '@/components/core/list/listRouteState';
import SocialSettings from '@/components/socialposts/SocialSettings.vue';
import SocialRowMenu from '@/components/socialposts/SocialRowMenu.vue';
import { createSocialTourSteps, stopSocialTour } from '@/components/socialposts/social-tour';
import { STATI, SOCIAL, stato, fonte, quando, scaricaBlob } from '@/components/socialposts/formato';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'SocialPosts',
	// pagina, righe, ordinamento, ricerca e stato stanno nell'URL: refresh e ritorno dalla scheda ripartono da li'
	mixins: [listRouteState({ filters: { status: 'string' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createSocialTourSteps(), { onStop: stopSocialTour }) };
	},
	components: { TourOverlay, KeyValueCard, SectionCard, SocialSettings, SocialRowMenu },
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: { status: '' },
				options: { sortBy: ['publishedAt'], sortDesc: [false], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: '', value: 'image', sortable: false },
				{ text: 'Prodotto', value: 'item_name' },
				{ text: 'Fonte', value: 'source', sortable: false },
				{ text: 'Social', value: 'platforms', sortable: false },
				{ text: 'Stato', value: 'status' },
				{ text: 'Pubblicazione', value: 'publishedAt' },
			],
			STATI,
			social: SOCIAL,
			setting: { times: 8, sources: { viewed: 1, sold: 1, new: 1, offer: 1 }, platforms: [], lang: '', hours: [], excludeDays: 90 },
			templates: [],
			options: {},
			lingue: [],
			impostazioniAperte: false,
			generando: false,
			dialogGenera: false,
			dialogPubblica: false,
			daPubblicare: null,
			dialogconfirm: false,
			daEliminare: null,
		};
	},
	sockets: {
		// piano generato o post pubblicato: il backend manda la notifica e la lista si ricarica
		MESSAGE_NOTIFY() {
			this.generando = false;
			this.getDataFromApi(false);
		},
	},
	async mounted() {
		this.listLoad();
		try {
			const [options, impostazioni, templates] = await Promise.all([this.fetchOptions(), this.fetchSettings(), this.fetchTemplates(), this.getProfile()]);
			this.options = options || {};
			this.setting = { ...this.setting, ...((impostazioni && impostazioni.setting) || {}) };
			this.templates = templates || [];
			this.lingue = _.filter(this.getSettings.languages, { is_active: true }).map(l => l.lang);
		} catch (err) {
			console.log(err);
		}
	},
	computed: {
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		testoElimina() {
			const t = this.daEliminare;
			if (t && t.__template) return `Il template «${t.name}» viene eliminato. I post che lo usano restano come sono.`;
			return 'Il post viene eliminato dal piano. Se è già uscito sui social, lì resta: va tolto dalla pagina.';
		},
		...mapGetters({
			getItems: 'socialposts/getItems',
			getSettings: 'settings/getSetting',
		}),
	},
	methods: {
		...mapMutations({ setPreload: 'settings/setPreload', setLogout: 'profile/setLogout' }),
		...mapActions({
			getProfile: 'profile/getProfile',
			fetchItems: 'socialposts/asyncFetchData',
			fetchOptions: 'socialposts/fetchOptions',
			fetchSettings: 'socialposts/fetchSettings',
			saveSettings: 'socialposts/saveSettings',
			fetchTemplates: 'socialposts/fetchTemplates',
			saveTemplate: 'socialposts/saveTemplate',
			removeTemplate: 'socialposts/deleteTemplate',
			generatePlan: 'socialposts/generatePlan',
			setStatus: 'socialposts/setStatus',
			publish: 'socialposts/publish',
			download: 'socialposts/download',
			remove: 'socialposts/deleteItem',
			destroyData: 'socialposts/destroyData',
		}),
		stato,
		fonte,
		quando,
		campiCard(item) {
			return [
				{ label: 'Stato', value: stato(item.status).label, strong: true },
				{ label: 'Pubblicazione', value: item.publishedAt ? `${this.$moment(item.publishedAt).format('DD/MM/YYYY HH:mm')} · ${quando(item.publishedAt)}` : '' },
				{ label: 'Titolo', value: item.payoff },
				{ label: 'Fonte', value: fonte(item.source).label },
				{ label: 'Social', value: (item.platforms || []).map(p => SOCIAL[p].label).join(', ') },
			];
		},
		esito(item, p) {
			return (item.shared && item.shared[p]) || null;
		},
		esitoColore(item, p) {
			const e = this.esito(item, p);
			if (e && e.error) return 'error';
			return e && e.at ? SOCIAL[p].colore : 'grey';
		},
		esitoTitolo(item, p) {
			const e = this.esito(item, p);
			if (e && e.error) return `${SOCIAL[p].label}: ${e.error}`;
			return e && e.at ? `${SOCIAL[p].label}: fatto` : SOCIAL[p].label;
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 6000, text };
		},
		errore(err) {
			const res = err.response;
			if (res && res.status === 401) {
				this.setLogout();
				this.$router.push('/login');
				return;
			}
			const errors = res && res.data && res.data.error;
			this.notifica('error', _.isArray(errors) ? errors.map(e => e.msg).join(', ') : (res && res.data && res.data.message) || err.message);
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		pulisciRicerca() {
			this.searchfield = '';
			this.getSearch();
		},
		getDataFromApi(preload = true) {
			if (preload) this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => preload && this.setPreload(false));
		},
		async salvaImpostazioni() {
			this.setPreload(true);
			try {
				const out = await this.saveSettings({ active: true, setting: this.setting });
				this.setting = { ...this.setting, ...out.setting };
				this.notifica('success', 'Impostazioni salvate');
			} catch (err) {
				this.errore(err);
			} finally {
				this.setPreload(false);
			}
		},
		async rendiPredefinito(t) {
			try {
				await this.saveTemplate({ _id: t._id, name: t.name, isDefault: true });
				this.templates = await this.fetchTemplates();
				this.notifica('success', `«${t.name}» è il template predefinito`);
			} catch (err) {
				this.errore(err);
			}
		},
		eliminaTemplate(t) {
			this.daEliminare = { ...t, __template: true };
			this.dialogconfirm = true;
		},
		async genera() {
			this.dialogGenera = false;
			this.generando = true;
			try {
				await this.generatePlan();
				this.notifica('success', 'Generazione avviata: ti avvisiamo quando i post sono pronti');
			} catch (err) {
				this.generando = false;
				this.errore(err);
			}
		},
		nuovo() {
			this.$router.push('/social-posts/new');
		},
		// la scheda del post e' una pagina: la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.$router.push(`/social-posts/${item._id}`);
		},
		chiediPubblica(item) {
			this.daPubblicare = item;
			this.dialogPubblica = true;
		},
		async pubblica() {
			this.dialogPubblica = false;
			if (!this.daPubblicare) return;
			this.setPreload(true);
			try {
				await this.publish(this.daPubblicare);
				this.notifica('success', 'Post pubblicato');
			} catch (err) {
				this.errore(err);
			} finally {
				this.daPubblicare = null;
				this.setPreload(false);
				this.getDataFromApi(false);
			}
		},
		async cambiaStato(item, status) {
			this.setPreload(true);
			try {
				await this.setStatus({ _id: item._id, status });
				this.notifica('success', status === 'ANNULLATO' ? 'Post annullato: non verrà pubblicato' : 'Stato aggiornato');
				await this.getDataFromApi(false);
			} catch (err) {
				this.errore(err);
			} finally {
				this.setPreload(false);
			}
		},
		async scarica(item, format) {
			this.setPreload(true);
			try {
				const blob = await this.download({ post: { ...item, item: item.item }, format });
				scaricaBlob(blob, `${_.kebabCase(item.item_name || 'post')}-${format}.png`);
			} catch (err) {
				this.notifica('error', 'Immagine non generata, riprova');
			} finally {
				this.setPreload(false);
			}
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			this.dialogconfirm = false;
			const t = this.daEliminare;
			if (!t) return;
			this.setPreload(true);
			try {
				if (t.__template) {
					await this.removeTemplate(t);
					this.templates = await this.fetchTemplates();
					this.notifica('success', 'Template eliminato');
				} else {
					await this.remove(t);
					await this.getDataFromApi(false);
					this.notifica('success', 'Post eliminato');
				}
			} catch (err) {
				this.errore(err);
			} finally {
				this.daEliminare = null;
				this.setPreload(false);
			}
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
.sp-page {
	max-width: 1600px;
}
.sp-top {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px 12px;
	margin-bottom: 16px;
}
.sp-title {
	font-size: 20px;
	font-weight: 600;
	color: #1f2d3d;
}
.sp-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.sp-page ::v-deep .section-card {
	height: auto;
}
.sp-filters {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px 16px;
	margin-bottom: 8px;
}
.sp-search {
	max-width: 300px;
}
.sp-states {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}
.sp-empty {
	text-align: center;
	padding: 32px 0;
	color: #5f6b7a;
}
.sp-thumb {
	width: 48px;
	height: 48px;
	border-radius: 6px;
	background: #f2f4f8;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.sp-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: #fff;
}
.sp-payoff {
	max-width: 420px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.sp-source {
	font-size: 12px;
	white-space: nowrap;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.sp-cards,
.sp-cards tr {
	display: block;
	width: 100%;
}
.sp-cards tr,
.sp-cards tr:hover {
	background: transparent !important;
}
.sp-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
</style>
